module.exports = __webpack_public_path__ + "static/media/22-en.c67aa2e4.svg";